import { Pipe, PipeTransform } from "@angular/core";
import { IBaseCard, isJobsBillingCard } from "@app/views-interfaces";

@Pipe({
    name: "cardTitle",
    pure: true,
    standalone: false,
})
export class CardTitlePipe implements PipeTransform {
    transform(card: IBaseCard): string {
        return titleFromCard(card);
    }
}

export function titleFromCard(card: IBaseCard | null | undefined) {
    if (!card) {
        return "";
    }

    if (isJobsBillingCard(card) && card?.contactInformation) {
        return [card.contactInformation.firstName, card.contactInformation.lastName].join(" ").trim();
    }

    if (card?.name) {
        return card.name;
    }

    if (card?.contactInformation) {
        return [card.contactInformation.firstName, card.contactInformation.lastName].join(" ").trim();
    }

    return "";
}
